module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.meetingType) + " Check-in")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitCheckin()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("How did the live session go?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.overall),
      expression: "checkin.overall"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.checkin.overall = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Is there anything on your mind that you'd like to share?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.comments),
      expression: "checkin.comments"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.checkin.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkin.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.localStorage.roles.includes('GlobalMentor') || _vm.localStorage.roles.includes('Recruiter')) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Did you have enough time to cover all the questions?")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.sufficientTime),
      expression: "checkin.sufficientTime"
    }],
    attrs: {
      "type": "radio",
      "name": "sufficient_time",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.checkin.sufficientTime, "true")
    },
    on: {
      "__c": function($event) {
        _vm.checkin.sufficientTime = "true"
      }
    }
  }), _vm._v("Yes")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.sufficientTime),
      expression: "checkin.sufficientTime"
    }],
    attrs: {
      "type": "radio",
      "name": "sufficient_time",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.checkin.sufficientTime, "false")
    },
    on: {
      "__c": function($event) {
        _vm.checkin.sufficientTime = "false"
      }
    }
  }), _vm._v("No")])]), _vm._v(" "), (_vm.checkin.sufficientTime == 'false') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("If no, please explain ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.timeExplanation),
      expression: "checkin.timeExplanation"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.checkin.timeExplanation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkin.timeExplanation = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("How knowledgeable was your " + _vm._s(_vm.meetingType) + "?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.knowledgeRating),
      expression: "checkin.knowledgeRating"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.checkin.knowledgeRating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("How organized was your " + _vm._s(_vm.meetingType) + "?")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.organizationRating),
      expression: "checkin.organizationRating"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.checkin.organizationRating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkin.important),
      expression: "checkin.important"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkin.important) ? _vm._i(_vm.checkin.important, null) > -1 : (_vm.checkin.important)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkin.important,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkin.important = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkin.important = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkin.important = $$c
        }
      }
    }
  }), _vm._v("\n                        Mark this as important for Think Tank staff to see and be notified.\n                    ")]), _vm._v(" "), _vm._m(0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cdf1c020!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GlobalCheckin.vue
// module id = 2103
// module chunks = 2